import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../api/api';
import { IconEye, IconArrowRight, IconFolderOpen } from './Icons';

const ProjectArea = ({ projects: propProjects }) => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        if (propProjects && propProjects.length > 0) {
            setProjects(propProjects);
            return;
        }

        const getProjects = async () => {
            try {
                const { data } = await api.fetchProjects();
                setProjects(data);
            } catch (error) {
                console.log(error);
            }
        };

        getProjects();
    }, [propProjects]);

    return (
        <div>
            <section id="portfolio" className="projects-area py-50 rel z-1">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-12">
                            <div className="section-title text-center mb-60 wow fadeInUp delay-0-2s">
                                <span className="sub-title mb-15">Latest Works</span>
                                <h2>Explore My Popular <span>Projects</span></h2>
                            </div>
                        </div>
                    </div>

                    {projects.length > 0 ? (
                        projects.slice(0, 4).map((project, index) => (
                            <div key={project._id || index} className="row align-items-center mb-5 p-4 executive-card">
                                <div className={`col-lg-6 ${index % 2 !== 0 ? 'order-lg-2' : ''}`}>
                                    <div className="project-image wow fadeInLeft delay-0-2s" style={{ borderRadius: '14px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)' }}>
                                        <img
                                            src={api.getImageUrl(project.img)}
                                            alt={project.title}
                                            style={{ width: '100%', height: '320px', objectFit: 'cover' }}
                                        />
                                    </div>
                                </div>
                                <div className={`col-xl-5 col-lg-6 ${index % 2 !== 0 ? 'ms-auto' : ''}`}>
                                    <div className="project-content wow fadeInRight delay-0-2s p-2">
                                        <div className="d-flex flex-wrap gap-2 mb-3">
                                            {project.technologies && project.technologies.map((tech, tIdx) => (
                                                <span key={tIdx} className="tech-pill-senior">
                                                    {tech}
                                                </span>
                                            ))}
                                        </div>
                                        <h2 className="mb-3" style={{ fontSize: '24px', fontWeight: 700, color: '#F8FAFC' }}>
                                            <Link to={`/project-details/${project._id || project.id}`} style={{ color: '#F8FAFC', textDecoration: 'none' }} className="hover:text-sky-400">
                                                {project.title}
                                            </Link>
                                        </h2>
                                        <p style={{ color: '#94A3B8', fontSize: '15px', lineHeight: '1.65' }}>{project.shortDesc || project.desc}</p>
                                        <div className="mt-4">
                                            <Link to={`/project-details/${project._id || project.id}`} className="btn-executive-secondary">
                                                <IconEye color="#38BDF8" className="me-2" /> Case Study & Details <IconArrowRight color="#38BDF8" className="ms-2" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        /* 3 Skeleton Project Cards */
                        [...Array(3)].map((_, i) => (
                            <div key={i} className="row align-items-center mb-5 p-4 executive-card">
                                <div className="col-lg-6">
                                    <div className="skeleton-shimmer skeleton-image-box"></div>
                                </div>
                                <div className="col-xl-5 col-lg-6 ms-auto mt-4 mt-lg-0">
                                    <div className="d-flex gap-2 mb-3">
                                        <div className="skeleton-shimmer skeleton-line w-25"></div>
                                        <div className="skeleton-shimmer skeleton-line w-25"></div>
                                    </div>
                                    <div className="skeleton-shimmer skeleton-line-title mb-3"></div>
                                    <div className="skeleton-shimmer skeleton-line w-100 mb-2"></div>
                                    <div className="skeleton-shimmer skeleton-line w-90 mb-2"></div>
                                    <div className="skeleton-shimmer skeleton-line w-75 mb-4"></div>
                                    <div className="skeleton-shimmer skeleton-line w-40" style={{ height: '40px', borderRadius: '10px' }}></div>
                                </div>
                            </div>
                        ))
                    )}

                    <div className="project-btn text-center wow fadeInUp delay-0-2s mt-4">
                        <Link to="/projects" className="btn-executive-primary py-3 px-5" style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <IconFolderOpen className="me-2" /> View More Projects <IconArrowRight className="ms-2" />
                        </Link>
                    </div>
                </div>
                <div className="bg-lines">
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                </div>
            </section >
        </div >
    )
}

export default ProjectArea;